import { render, staticRenderFns } from "./UnitData.vue?vue&type=template&id=2f5efb41&scoped=true"
import script from "./UnitData.vue?vue&type=script&lang=ts"
export * from "./UnitData.vue?vue&type=script&lang=ts"
import style0 from "./UnitData.vue?vue&type=style&index=0&id=2f5efb41&prod&lang=scss"
import style1 from "./UnitData.vue?vue&type=style&index=1&id=2f5efb41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5efb41",
  null
  
)

export default component.exports